<div id="dropzone" class="full-screen-dropzone">
  <ngx-file-drop #fileUploadDropzone (onFileDrop)="fileDrop($event)" (onFileOver)="fileOver()"
    (onFileLeave)="fileLeave()">
  </ngx-file-drop>
  <span class="msg mat-body-2" translate>Drag and drop files here</span>
</div>

<button mat-flat-button color="primary" (click)="clickFileInput()"
  [matTooltip]="'You can also drag and drop files in this window.' | translate">
  <mat-icon class="mr1">add</mat-icon>
  <span>{{text()}}</span>
</button>

<input #fileUploadInput type="file" (change)="fileChange($event)" placeholder="Upload file" style="display: none;"
  multiple />

@if (uploads.length > 0) {
  <mat-card appearance="outlined" class="card-padding mt2">
    <mat-card-header>
      @if (isUploading()) {
        <mat-card-title translate>Uploading documents</mat-card-title>
      } @else {
        <mat-card-title translate>Documents to check</mat-card-title>
      }
    </mat-card-header>
    <mat-card-content>
      <mat-list class="uploader">
        @for (upload of uploads; track upload) {
          <mat-list-item [@fadeAnimation]="'in'">
            <div class="uploading mr2">
              <h4 class="title" mat-line>{{upload.originalFileName}}</h4>
              <div mat-line>
                <mat-progress-bar [mode]="upload.isAnalysing ? 'indeterminate' : 'determinate'" [value]="upload.percentageComplete" [color]="upload.hasError ? 'warn' : 'primary'"></mat-progress-bar>
              </div>
              <div class="sub" mat-line>
                @if (upload.hasError) {
                  <span class="failed">
                    <mat-icon class="icon-small">error_outline</mat-icon>
                    <span translate>Upload failed</span>
                  </span>
                } @else if (upload.isAnalysing) {
                  <span class="analysing" translate>Analysing document…</span>
                } @else if (upload.classification?.applied && upload.document?.documentType) {
                  <span class="classified" [matTooltip]="upload.classification.classification?.reasoning">
                    @if (upload.isAutoValidated) {
                      <mat-icon class="icon-small">verified</mat-icon>
                      <span translate>Indexed as</span>&nbsp;{{upload.document.documentType.name}}
                    } @else {
                      <mat-icon class="icon-small">auto_awesome</mat-icon>
                      <span translate>Recognised as</span>&nbsp;{{upload.document.documentType.name}}
                    }
                    @if (upload.document.issued) {
                      &middot; <span translate>Issued</span>&nbsp;{{upload.document.issued | date:'shortDate'}}
                    }
                    @if (upload.document.expires) {
                      &middot; <span translate>Expires</span>&nbsp;{{upload.document.expires | date:'shortDate'}}
                    }
                    @if (upload.document.year) {
                      &middot; <span translate>Year</span>&nbsp;{{upload.document.year}}
                    }
                    @if (linkText(upload); as link) {
                      &middot; {{link}}
                    }
                  </span>
                } @else if (suggestedDocumentType(upload); as suggestion) {
                  <span class="classified" [matTooltip]="upload.classification.classification?.reasoning">
                    <mat-icon class="icon-small">help_outline</mat-icon>
                    <span translate>Possibly</span>&nbsp;{{suggestion.name}}
                    @if (linkText(upload); as link) {
                      &nbsp;({{link}})
                    },&nbsp;<span translate>please check</span>
                  </span>
                } @else if (upload.classification) {
                  <span translate>Not recognised, please categorize the document</span>
                  @if (linkText(upload); as link) {
                    &nbsp;&middot; {{link}}
                  }
                } @else {
                  <span translate>Upload progress</span>&nbsp;
                  {{upload.percentageComplete | number:'1.0-0'}}%
                }
              </div>
            </div>
            @if (upload.hasError) {
              <button [@fadeAnimation]="'in'" (click)="retryUpload(upload)" class="button-small mr1"
                [matTooltip]="'Upload the file again' | translate" mat-stroked-button color="primary">
                <mat-icon class="mr1">refresh</mat-icon>
                <span translate>Retry</span>
              </button>
              <button [@fadeAnimation]="'in'" (click)="dismissUpload(upload)" class="button-small" mat-stroked-button>
                <mat-icon class="mr1">close</mat-icon>
                <span translate>Remove</span>
              </button>
            }
            @if (upload.isComplete && canValidate(upload)) {
              <button [@fadeAnimation]="'in'" (click)="validateDocument(upload)" class="button-small mr1"
                [matTooltip]="'The recognised document type and dates are correct' | translate" mat-stroked-button color="primary">
                <mat-icon class="mr1">check</mat-icon>
                <span translate>OK</span>
              </button>
            }
            @if (upload.isComplete) {
              <!-- Wait for the analysis, otherwise the detected values could overwrite what the user is editing -->
              <button [@fadeAnimation]="'in'" (click)="editDocument(upload)" class="button-small"
                [disabled]="upload.isAnalysing || upload.isValidating" mat-stroked-button>
                <mat-icon class="mr1">edit</mat-icon>
                @if (upload.classification?.classification?.documentTypeId) {
                  <span translate>Check</span>
                } @else {
                  <span translate>Categorize</span>
                }
              </button>
            }
          </mat-list-item>
        }
      </mat-list>
    </mat-card-content>
  </mat-card>
}